<template>
  <div
    v-if="projectItemData"
    class="project-item"
    :class="{'project-close': projectItemData.status*1 !== 1}"
    style="cursor: pointer;"
    @click.prevent.stop="clickHandle(projectItemData)"
  >
    <div class="project-item-tit">
      <h4>{{ projectItemData.projectname }}</h4>
    </div>
    <div class="project-item-content">
      <p>广告账户：{{ projectItemData.conversionnum }}个 </p>
      <p>{{ projectItemData.createusername }}创建于<span v-if="projectItemData.createdAt">{{ projectItemData.createdAt.replace(/-/g, '.') }}</span></p>
    </div>
    <div class="pro-item-state">
      <!-- "1575": "正常" -->
      <span
        v-if="projectItemData.status*1 === 1"
        class="pro-item-status"
      >
        <i />
        {{ $t('message["1575"]') }}
      </span>
      <!-- 401：关闭 -->
      <span
        v-else
        class="pro-item-status has-close"
      >
        <i />
        {{ $t('message["401"]') }}
      </span>
      <div
        class="project-tool-config"
      >
        <manage-pro :project-item-data="projectItemData" />
      </div>
    </div>
  </div>
</template>

<script>
import ManagePro from './managePro/ManagePro'
import { mapActions } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  name: 'ProjectItemRealback',
  components: {
    ManagePro
  },
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('organization/orgRealback', ['chooseProject']),
    async clickHandle (data) {
      const { projectid } = data
      const realbackCid = getStorage('realbackCid')
      if (data.status * 1 === 1) {
        let chain = await this.chooseProject({
          cid2: this.$route.query.cid,
          cid: realbackCid,
          projectid
        })
        chain
          .onSuccess(async (payload) => {
            const pid = payload.Project
            const $location = window.location
            if (process.env.NODE_ENV === 'development') {
              location.href = '//' + $location.hostname + ':94/wechatservices/project/' + pid + '/mp'
            } else {
              location.href = '//' + $location.host + '/wechatservices/project/' + pid + '/mp'
            }
          })
      } else {
        this.$warning({
          content: this.$t('message["1327"]') + '！'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.project-item::v-deep {
  width: 330px;
  height: 171px;
  box-shadow: 0 2px 4px 0 #eceff1;
  border: solid 1px #eceff1;
  background-color: #fff;
  border-radius: 4px;
  float: left;
  padding: 25px 24px 2px;
  box-sizing: content-box;
  margin:0 24px 24px 3px;
  margin-bottom: 24px;

  .project-item-tit {
    position: relative;
    margin-bottom: 42px;
    h4 {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .project-item-content {
    margin: 40px 0 18px;
    color: #C3C3C3;
    font-size: 12px;
    line-height: 24px;
  }
  .project-tool-config {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .pro-item-state {
    padding-top: 8px;
    position: relative;
    font-size: 12px;
    z-index: 4;
    .pro-item-status {
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      padding: 0 4px;
      border: 1px solid #eceff1;
      color: #42c27e;
      vertical-align: middle;
      font-size: 12px;
      i {
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background:#42c27e;
        vertical-align: middle;
        margin-bottom: 4px;
      }
    }

    .has-close {
      color: #333;
      i {
        background: #e0e0e0;
      }
    }
  }
}

.project-item:hover {
  box-shadow: 0 8px 8px 0 #eceff1;
}

.mr-0 {
  margin-right: 0;
}
.project-close {
  opacity: 0.5;
}
.project-close:hover {
  opacity: 1;
}
</style>
